export default __webpack_public_path__ + "static/media/girl6.575202ec.jpg";